import React from 'react';
import { Card } from 'react-bootstrap';
import { SiSalesforce } from 'react-icons/si';
import { FaKey, FaRegUser, FaProjectDiagram } from 'react-icons/fa';
import { MdHttp } from 'react-icons/md';

const SalesforceSourceHelper = () => (
  <Card.Body className='text-left'>
    <div className='mb-4 d-flex'>
      <div className='pr-3'>
        <SiSalesforce color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Connected app</p>
        <p className='helper-content'>
          Create a connected app in the org with OAuth enabled and the <code>api</code> scope. For
          JWT bearer, upload a certificate under &ldquo;Use digital signatures&rdquo; and set
          Permitted Users to &ldquo;Admin approved users are pre-authorized&rdquo;, then assign the
          integration user&rsquo;s profile or a permission set.
        </p>
      </div>
    </div>
    <div className='mb-4 d-flex'>
      <div className='pr-3'>
        <MdHttp color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Login URL</p>
        <p className='helper-content'>
          Your org&rsquo;s My Domain URL, or one of the shared hosts (login.salesforce.com,
          test.salesforce.com). This is also the JWT audience, so it needs to be the org you mean.
          If Salesforce rejects the audience, override it under Advanced rather than changing the
          login URL. Client credentials is the exception: that flow is served only from your own
          My Domain URL.
        </p>
      </div>
    </div>
    <div className='mb-4 d-flex'>
      <div className='pr-3'>
        <FaKey color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Consumer key &amp; secret / private key</p>
        <p className='helper-content'>
          The consumer key identifies the connected app. JWT bearer signs a token with the private
          key matching the uploaded certificate; client credentials sends the consumer secret.
          Secrets are stored encrypted and never shown again.
        </p>
      </div>
    </div>
    <div className='mb-4 d-flex'>
      <div className='pr-3'>
        <FaRegUser color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Integration user</p>
        <p className='helper-content'>
          A dedicated, API-enabled user with read access to every object and field you want
          described and discovered. Field-level security hides fields from the Describe, so a
          field the user cannot read is absent from the Data Graph and from discovery.
        </p>
      </div>
    </div>
    <div className='d-flex'>
      <div className='pr-3'>
        <FaProjectDiagram color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Describe</p>
        <p className='helper-content'>
          &ldquo;Describe&rdquo; reads the org&rsquo;s object model (objects, fields, lookups and
          master-detail relationships) into the Data Graph. It costs about one API call per object
          against the org&rsquo;s daily allowance.
        </p>
      </div>
    </div>
  </Card.Body>
);

export default SalesforceSourceHelper;
